<template>
    <div id="map" style="width: 100%; height: 500px" class="mh-75"></div>
</template>

<script>
import 'mapbox-gl/dist/mapbox-gl.css';
import '@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css';
import MapBox from '../mixins/MapBox/Map';

export default {
    mixins: [MapBox]
};
</script>